import { Typography } from '@components';
import { CurrencyFormatter, TruncateString } from '@utils';
import React from 'react';
import Table from './Table';
import TableItem from './TableItem';
import TableRow from './TableRow';

interface props {
  data: any;
}

export const SimMetricsTable = ({ data }: props) => {
  const headers = ['#', 'Categorie', 'Type', 'Waarde'];
  let t = 0;

  return (
    <div>
      <Table header={headers}>
        {Object.keys(data).map((number) => {
          const item = data[number];

          // ✅ groepeer per metric_name
          const groupedByMetric = Object.values(
            item.metrics.reduce((acc, m) => {
              if (!acc[m.metric_name]) {
                acc[m.metric_name] = {
                  metric_name: m.metric_name,
                  items: [],
                };
              }

              acc[m.metric_name].items.push(m);
              return acc;
            }, {})
          );

          const total =
            item.metrics?.reduce((sum, m) => sum + (m.value ?? 0), 0) ?? 0;

          t = t + total;

          return (
            <React.Fragment key={number}>
              {groupedByMetric.map((metricGroup: any, groupIndex) => {
                const groupTotal = metricGroup.items.reduce(
                  (sum, m) => sum + (m.value ?? 0),
                  0
                );

                return (
                  <React.Fragment key={`${number}-${groupIndex}`}>
                    {/* ✅ metric_name header */}
                    <TableRow>
                      <TableItem type="small">
                        {groupIndex === 0 ? (
                          <Typography
                            tag="span"
                            type="labelSemiBold"
                            color="blue"
                          >
                            {number}
                          </Typography>
                        ) : (
                          ''
                        )}
                      </TableItem>

                      <TableItem type="small">
                        <Typography tag="span" type="labelSemiBold">
                          <TruncateString
                            text={metricGroup.metric_name}
                            limit={40}
                          />
                        </Typography>
                      </TableItem>

                      <TableItem> </TableItem>
                      <TableItem> </TableItem>
                    </TableRow>

                    {/* ✅ subdivisions */}
                    {metricGroup.items.map((metric, i) => (
                      <TableRow key={`${number}-${groupIndex}-${i}`}>
                        <TableItem> </TableItem>

                        <TableItem> </TableItem>

                        <TableItem type="small">
                          <TruncateString text={metric.subdev} limit={40} />
                        </TableItem>

                        <TableItem type="small">
                          <CurrencyFormatter price={metric.value} />
                        </TableItem>
                      </TableRow>
                    ))}

                    <TableRow>
                      <TableItem> </TableItem>
                      <TableItem> </TableItem>
                      <TableItem className="text-right font-semibold text-sm">
                        Subtotaal
                      </TableItem>
                      <TableItem className="font-semibold text-sm">
                        <CurrencyFormatter price={groupTotal} />
                      </TableItem>
                    </TableRow>
                  </React.Fragment>
                );
              })}

              <TableRow className="bg-base-200">
                <TableItem> </TableItem>
                <TableItem> </TableItem>
                <TableItem className="text-right font-bold">Totaal</TableItem>
                <TableItem className="font-bold">
                  <CurrencyFormatter price={total} />
                </TableItem>
              </TableRow>
            </React.Fragment>
          );
        })}
        <TableRow>
          <TableItem> </TableItem>
          <TableItem> </TableItem>
          <TableItem> </TableItem>
          <TableItem className="font-bold">
            <Typography tag="span" type="bold">
              <CurrencyFormatter price={t} />
            </Typography>
          </TableItem>
        </TableRow>
      </Table>
    </div>
  );
};
